import { NgModule } from '@angular/core';

import { SharedModule } from '@shared';

import {RouteKeyNumberModule, RouteKeyNumbersModule} from 'planner-shared';

import { OptimizationComponent } from './optimization.component';
import { OptimizationSolutionComponent } from './solutions/optimization-solution.component';
import { OptimizationSettingsComponent } from './settings-modal/settings/optimization-settings.component';
import { OptimizationPreferencesBtnGroupComponent } from './settings-modal/preferences/btn-group/optimization-preferences-btn-group.component';
import { OptimizationPreferencesComponent } from './settings-modal/preferences/optimization-preferences.component';
import { OptimizationSettingsModalComponent } from './settings-modal/optimization-settings-modal.component';
import { RoutesComparisonModalComponent } from './routes-comparison-modal/routes-comparison-modal.component';
import { RouteComparisonSolutionComponent } from './routes-comparison-modal/route-comparison-solution/route-comparison-solution.component';

@NgModule({
    declarations: [
        OptimizationComponent,
        OptimizationSettingsModalComponent,
        OptimizationPreferencesComponent,
        OptimizationPreferencesBtnGroupComponent,
        OptimizationSolutionComponent,
        RoutesComparisonModalComponent,
        RouteComparisonSolutionComponent
    ],
    imports: [
        SharedModule,
        RouteKeyNumbersModule,
        RouteKeyNumberModule,
        OptimizationSettingsComponent
    ]
})
export class OptimizationModule {}
